import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const LoadingProgress = () => {
    const isLoading = useSelector(state => state.todoReducer.isloading);
    const [loadingProgress, setLoadingProgress] = useState(0);

    useEffect(() => {
        let interval;

        if (isLoading) {
            interval = setInterval(() => {
                setLoadingProgress(prevProgress => {
                    if (prevProgress < 60) {
                        return prevProgress + 2; // 0% hingga 75% dalam 10ms
                    } else if (prevProgress < 90) {
                        return prevProgress + 1; // 76% hingga 89% dalam 100ms
                    } else {
                        return prevProgress; // Maksimum 90%
                    }
                });
            },loadingProgress <60 ? 10 : 100);
        }

        return () => {
            clearInterval(interval);
        };
    }, [isLoading,loadingProgress]);

    if (!isLoading) {
        return null;
    }

    return (
        <div className="fixed top-0 left-0 w-full h-[1px] bg-gray-300 z-50">
            <div
                className="h-full bg-[#01016fff]"
                style={{ width: `${loadingProgress}%` }}
            ></div>
        </div>
    );
};

export default LoadingProgress;
